export const propInfo = {
  name: {
    saveSuccess: "Property name saved successfully",
    successTitle: "Success",
    saveError: "Could not save the property name",
  },
  capacity: {
    saveSuccess: "Capacity saved successfully",
    saveError: "Could not save the capacity",
  },
  location: {
    loadError: "Could not load the listing details.",
    appliedBulk: "Location applied to {count} linked accommodations",
    saveSuccess: "Location saved successfully",
    partialError: "Some accommodations could not be updated",
    savePropertySuccess: "Property location saved successfully",
    saveError: "Could not save the property location",
    loading: "Loading listing location…",
    noUnitsTitle: "This listing has no units set up yet.",
    noUnitsText: "Create at least one unit to set up the location.",
    bulkNotice: "This change will apply to the {count} accommodations linked to {name}.",
  },
  description: {
    saveSuccess: "Description saved successfully",
    saveError: "Could not save the description",
    cloneTitleNoun: "description",
    cloneItemNoun: "the description",
  },
};
